export const CONSENT_KEY = 'ctg_consent';
export const CONSENT_EVENT = 'ctg-consent-change';
const VERSION = 2;
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
const PREFERENCE_KEYS = ['ctg_history', 'ctg_bio_favs', 'ctg_bio_lang'];
let storageFailed = false;

export function readConsent() {
  if (storageFailed) return null;
  let stored;
  try { stored = localStorage.getItem(CONSENT_KEY); }
  catch { storageFailed = true; return null; }
  try {
    const choice = JSON.parse(stored);
    const now = Date.now();
    const legacy = choice?.version === 1;
    if ((!legacy && choice?.version !== VERSION) || typeof choice.preferences !== 'boolean' ||
        (!legacy && typeof choice.analytics !== 'boolean') ||
        !Number.isFinite(choice.savedAt) || !Number.isFinite(choice.expiresAt) ||
        choice.savedAt > now || choice.expiresAt <= now ||
        choice.expiresAt - choice.savedAt !== MAX_AGE) return null;
    // Keep valid v1 preferences and their original expiry, but never infer analytics consent.
    // Retain version 1 so the banner still requests a fresh choice; do not rewrite storage.
    return legacy ? { ...choice, analytics: false } : choice;
  } catch { return null; }
}

// Runtime default is not a saved affirmative consent choice.
export function isAnalyticsEnabled(choice = readConsent()) {
  if (storageFailed) return false;
  return choice === null || choice.version === 1 || choice.analytics === true;
}

export function clearPreferences() {
  for (const key of PREFERENCE_KEYS) {
    try { localStorage.removeItem(key); } catch { /* Storage may be disabled. */ }
  }
}

export function saveConsent(preferences, analytics = false) {
  const savedAt = Date.now();
  const choice = { version: VERSION, preferences: preferences === true, analytics: analytics === true, savedAt, expiresAt: savedAt + MAX_AGE };
  // Revocation clears optional data even if saving the new choice fails.
  if (!choice.preferences) clearPreferences();
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(choice));
  } catch {
    storageFailed = true;
    window.dispatchEvent(new Event(CONSENT_EVENT));
    return false;
  }
  storageFailed = false;
  window.dispatchEvent(new Event(CONSENT_EVENT));
  return true;
}

export function readPreference(key, fallback) {
  if (!readConsent()?.preferences) return fallback;
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
}

export function writePreference(key, value) {
  if (!readConsent()?.preferences) return;
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Keep tools usable without storage. */ }
}
